module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-cascader', {
    attrs: {
      "options": _vm.options,
      "props": _vm.props,
      "placeholder": "请选择",
      "loading": _vm.loading,
      "clearable": _vm.clearable,
      "disabled": _vm.disabled
    },
    on: {
      "active-item-change": _vm.handleItemChange,
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.currentValue),
      callback: function($$v) {
        _vm.currentValue = $$v
      },
      expression: "currentValue"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6230ddc0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/AreaCascader.vue
// module id = 341
// module chunks = 0